import { Theme, ThemeOptions } from '@mui/system/createTheme';
import linkBase from '../common/linkBase';
import ColourPalette from '../common/colorPalette';

export interface SolThemeOptions extends ThemeOptions {
  baselines: string[];
  baseMediaUrl: string;
  external: {
    bp: {
      palette: {
        primary: {
          main: string;
        };
      };
    };
    comcast: {
      palette: {
        primary: {
          main: string;
        };
      };
    };
  };
}

const getSolThemeOptions: (eqMainTheme: Theme) => SolThemeOptions = (
  eqMainTheme
) => ({
  baselines: ['20px', '28px'],
  baseMediaUrl: 'https://eqsolintusapp.blob.core.windows.net/web-resources',
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        p: {
          margin: 0,
        },
      },
    },
    MuiScopedCssBaseline: {
      styleOverrides: {
        root: {
          ...(eqMainTheme.components!.MuiCssBaseline!.styleOverrides as any)
            .body,
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          color: ColourPalette.palette.neutral['10'],
          a: {
            ...linkBase,
          },
          '&:empty': {
            minHeight: 0,
          },
        },
      },
    },
    MuiBox: {
      styleOverrides: {
        root: {
          '& .MuiFormControlLabel-root': {
            marginLeft: 0,
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginLeft: 0,
        },
      },
    },
  },
  external: {
    bp: {
      palette: {
        primary: {
          main: '#009B00', // custom brand color - do not change
        },
      },
    },
    comcast: {
      palette: {
        primary: {
          main: '#0088D2', // custom brand color - do not change
        },
      },
    },
  },
});

export default getSolThemeOptions;
